import React from 'react';

import {
  ListButton,
  TopToolbar,
} from 'react-admin';

import CancelRepairAction from './CancelRepairAction';

const RepairEditActions = () => (
  // Overrides the default RA behavior of offering a "Show" option
  // We always want to display the "Edit" view for Under Review statues
  <TopToolbar>
    <CancelRepairAction />
    <ListButton />
  </TopToolbar >
);

export default RepairEditActions;
